// Wait for the DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
    // Get all accordion items
    const accordionItems = document.querySelectorAll('.pet--item');
    
    // Add click event listener to each accordion header
    accordionItems.forEach(item => {
        const header = item.querySelector('.pet--item-head');
        
        header.addEventListener('click', function() {
            // Check if the clicked item is already open
            const isCurrentlyOpen = item.classList.contains('open');
            
            // Close all items first
            accordionItems.forEach(otherItem => {
                otherItem.classList.remove('open');
            });
            
            // If the clicked item wasn't already open, open it
            if (!isCurrentlyOpen) {
                item.classList.add('open');
            }
        });
    });
});